import { createAction, props } from '@ngrx/store';
import { CxApiMetadata } from '../../models/cx-api-metadata';

export const resetState = createAction('[API_METADATA] Reset State');
export const initEntity = createAction('[API_METADATA] Init Entity', props<{ id: string }>());
export const fetchEntity = createAction('[API_METADATA] Fetch Entity', props<{ id: string }>());
export const fetchEntityCompleted = createAction(
  '[API_METADATA] Fetch Entity completed',
  props<{ payload: CxApiMetadata & { ttl: number } }>(),
);
export const fetchEntityCanceled = createAction('[API_METADATA] Fetch Entity canceled', props<{ id: string }>());
export const fetchEntityReset = createAction('[API_METADATA] Fetch Entity reset', props<{ id: string }>());

export const CxApiMetadataActions = {
  resetState,

  initEntity,
  fetchEntity,
  fetchEntityCompleted,
  fetchEntityCanceled,
  fetchEntityReset,
};

export default CxApiMetadataActions;
